import {ChangeDetectionStrategy, Component, Input} from '@angular/core'
import {faPhone} from '@fortawesome/pro-solid-svg-icons/faPhone'
import {TranslocoDirective, TranslocoService} from '@ngneat/transloco'
import {ShareButtonComponent} from '../share-button/share-button.component'
import {PipesModule} from '../../pipes/pipes.module'
import {ApplicationRoute} from '../../../craft/utils/application.route'
import {PUBLIC_ROUTES} from '../../routing/public.routes'
import {OTHER_OFFERING_ID} from '../../../core/i18n/link.service'
import {CallToAction} from '../../../core/content/types/call-to-action.types'
import {ButtonModule} from '../../../craft/button/button.module'

@Component({
  selector: 'bgo-new-sticky-footer',
  imports: [TranslocoDirective, ShareButtonComponent, PipesModule, ButtonModule],
  templateUrl: './new-sticky-footer.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NewStickyFooterComponent {
  @Input() shareTitle!: string
  @Input() sharePlot!: string
  @Input() mainCallToAction?: CallToAction
  @Input() secondaryCallToAction?: CallToAction

  protected readonly phoneIcon = faPhone

  protected readonly defaultCta: CallToAction = {
    type: 'Path',
    label: this.transloco.translate('jobRequestBottomNavigation.jobRequestCta'),
    value: new ApplicationRoute(PUBLIC_ROUTES.JOB_REQUEST.path.replace(':offeringId', OTHER_OFFERING_ID)),
  }

  constructor(private readonly transloco: TranslocoService) {}

  getMainCallToAction() {
    if (this.mainCallToAction) {
      return this.mainCallToAction
    }
    return this.defaultCta
  }
}
